import { Event } from '@/event-bus/event';

export class MassEditHideWarningMultipleOrganisationsEvent extends Event<void> {}
